import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Sider
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import PageDetail from "./pages/PageDetail";
import Tilbud from "./pages/Tilbud";
import Kontakt from "./pages/Kontakt";
import Forbidden from "./pages/Forbidden";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-neutral-light font-sans antialiased">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Hovednavigation */}
      <Header />

      {/* Hovedindhold */}
      <main className="flex-grow">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<Home />} />

          {/* Dynamiske Arbejdsopgaver / Ydelser */}
          <Route path="/arbejdsopgaver/:slug" element={<ServiceDetail />} />

          {/* Særskilte sider */}
          <Route path="/referencer" element={<PageDetail slug="referencer" />} />
          <Route path="/indhent-tilbud" element={<Tilbud />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* Praktiske undersider */}
          <Route path="/privat" element={<PageDetail slug="privat" />} />
          <Route path="/erhverv" element={<PageDetail slug="erhverv" />} />
          <Route path="/medarbejdere" element={<PageDetail slug="medarbejdere" />} />
          <Route path="/godt-at-vide" element={<PageDetail slug="godt-at-vide" />} />

          {/* Fejlsider */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
